import { useMemo } from 'react';

import { useNotificationListQuery } from '@/entities/notification';
import { WORKFLOW_TYPE } from '@/types/workflowConst';

type UseSignalAlertTitlesOptions = {
  /** 업데이트 시 현재 alert의 alias를 제외 */
  excludeAlias?: string;
};

/**
 * Signal Alert 제목 목록을 조회하는 hook
 * 중복 검사에 사용
 */
export function useSignalAlertTitles(options?: UseSignalAlertTitlesOptions) {
  const { excludeAlias } = options ?? {};

  const { data: alerts = [] } = useNotificationListQuery([
    WORKFLOW_TYPE.SIGNAL_ALERT,
  ]);

  // 제목 Set으로 변환 (excludeAlias가 있으면 해당 alert 제외)
  const existingTitles = useMemo(() => {
    const filteredAlerts = excludeAlias
      ? alerts.filter((alert) => alert.alias !== excludeAlias)
      : alerts;

    return new Set(filteredAlerts.map((alert) => alert.title));
  }, [alerts, excludeAlias]);

  return { existingTitles };
}
